// Analog (film) camera bodies. Stored inside gear.cameras with a "film_" id
// prefix. They have no digital EXIF, so they are tracked in the inventory and
// (optionally) mapped to a Full-Frame 35mm profile in the settings calculator.
export const FILM_CAMERAS = [
  { id: "film_canon_ae1_program", label: "Canon AE-1 Program" },
  { id: "film_canon_ae1", label: "Canon AE-1" },
  { id: "film_canon_a1", label: "Canon A-1" },
  { id: "film_pentax_k1000", label: "Pentax K1000" },
  { id: "film_olympus_om1", label: "Olympus OM-1" },
  { id: "film_olympus_om10", label: "Olympus OM-10" },
  { id: "film_nikon_fm2", label: "Nikon FM2" },
  { id: "film_nikon_fe", label: "Nikon FE" },
  { id: "film_minolta_x700", label: "Minolta X-700" },
  { id: "film_minolta_srt101", label: "Minolta SRT 101" },
  { id: "film_minolta_maxxum_300si", label: "Minolta Maxxum 300si" },
  { id: "film_yashica_fx3", label: "Yashica FX-3" },
];

export const isFilmCameraId = (id) => String(id || "").startsWith("film_");

export const getFilmCameraLabel = (id) => {
  const f = FILM_CAMERAS.find((c) => c.id === id);
  return f ? f.label : null;
};
